export class VideoResource {
    id: string;
    sensorId: string;
    fileName: string;
    url: string;
    timestampStart: number;
    timestampEnd: number;
}
